import axios from "axios";

const treinamentoStore = {
  namespaced: true,
  state: {
    treinamentos: [],
    filtro: {
      tipo: "",
    },
    tiposTreinamento: [
      {
        descricao: "Treinamentos Disponíveis",
        tipo: "treinamentos-disponiveis",
        icon: "mdi-cast-education",
      },
      {
        descricao: "Meus Treinamentos",
        tipo: "meus-treinamentos",
        icon: "mdi-account-school-outline",
      },
    ],
  },
  mutations: {
    setTreinamentos(state, treinamentos) {
      state.treinamentos = treinamentos;
    },
    setTipo(state, tp) {
      state.tipo = tp;
    },
  },
  actions: {
    async getTreinamentos(context) {
      context.commit("setTreinamentos", []);
      await axios
        .get("/colaborador/treinamentos", {
          params: context.state.filtro,
        })
        .then((res) => {
          if (res.data.success) {
            context.commit("setTreinamentos", res.data.data);
          }
        });
    },
  },
  getters: {},
};

export default treinamentoStore;
